import { useContext, useEffect } from "react";
import { useSearchParams } from "react-router";

import { OrganisationContext } from "../providers/OrganisationProvider";

export const useSetOrApplyQueryOrganisation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { organisation, organisations, setOrganisation } = useContext(OrganisationContext);

  useEffect(() => {
    const organisationParam = searchParams.get("organisation");
    if (organisationParam) {
      if (organisation.uniqueId !== organisationParam) {
        const moveToOrganisation = organisations.find(
          (findOrganisation) => findOrganisation.uniqueId === organisationParam
        );
        if (moveToOrganisation) setOrganisation(moveToOrganisation);
      }
    } else setSearchParams(`?${new URLSearchParams({ organisation: organisation.uniqueId })}`);
  }, [organisation.uniqueId, organisations, searchParams, setOrganisation, setSearchParams]);
};
